import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'


export const state = {
  paxTotals: {},
}

export const mutations = {
  SET_DATA(state, payload) {
    Vue.set(state.paxTotals, payload.flightId, payload.data)
  },
}

export const getters = {
  getPaxTotalsByFltId: (state, getters, rootState) => (flightId) => {
    return state.paxTotals[rootState.flights.selectedFlightId]
  },
}

export const actions = {
  GET_DATA({ commit, dispatch, getters }, flightId) {
    
    axios
      .get(`${window.config.apiBaseUrl}paxTotals/flightid/${flightId}`)
      .then((response) => {
        const data = response.data.Results[0]
        const payload = {
          flightId: flightId,
          data: data,
        }
        commit('SET_DATA', payload)
      })
      .catch((error) => {
        console.log(error)
      })
  },
}
